import type { Configuration, IPublicClientApplication, RedirectRequest } from '@azure/msal-browser'
import { createStandardPublicClientApplication, LogLevel } from '@azure/msal-browser'
import { logger } from '../common/logger'
import { env } from '../environment/env'

const msalConfig: Configuration = {
  auth: {
    clientId: `${env.AUTH_MSENTRAID_CLIENT_ID}`,
    authority: 'https://login.microsoftonline.com/7b4916b5-8728-4eea-ad9a-ddcd8e06cb1c',
    redirectUri: '/',
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            logger.logError(new Error(message))
            break
          case LogLevel.Warning:
            logger.logError(new Error(message))
            break
          case LogLevel.Info:
            logger.logDebug(message)
            break
          case LogLevel.Verbose:
            logger.logDebug(message)
            break
          case LogLevel.Trace:
            logger.logDebug(message)
            break
          default:
            logger.logDebug(`Unknown log level ${level as any}. Message: ${message}`)
            break
        }
      },
    },
  },
}

export interface SignInContext {
  msalInstance: IPublicClientApplication
}

export default async function msalSignIn(): Promise<SignInContext> {
  const msalInstance = await createStandardPublicClientApplication(msalConfig)
  await msalInstance.handleRedirectPromise()

  const loginRequest: RedirectRequest = {
    scopes: ['openid', 'profile', 'offline_access'],
    redirectUri: '/',
  }

  const accounts = msalInstance.getAllAccounts()
  if (accounts.length === 0) {
    await msalInstance.loginRedirect(loginRequest)
  }
  else {
    msalInstance.setActiveAccount(accounts[0])
  }

  return { msalInstance }
}
